
<template>
  <div
    class="w-full h-auto  min-h-screen mt-3 justify-between bg-white space-y-9 rounded-t-[20px]"
  >
    <HeaderComponent page-title="Teams" />
    <div class="mx-8 my-">
      <div class="hr-container space-x-5 mb-">
        <div class="flex items-center justify-between">
          <div class="space-y-3">
            <p class="font-semibold text-bodyText text-[20px]">Team</p>
            <p v-if="isAdmin || isManager" class="text-bodyText text-[14px]">
              Create a team for your projects and Add Talents
            </p>
          </div>

          <div class="flex gap-2">
            <button
              v-if="isManager || isAdmin"
              @click="openModal('addTalent')"
              class="flex border border-grayLight rounded-[8px] text-bodyText text-[14px] font-medium px-6 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
            >
              Add Talent to Team
            </button>

            <button
              v-if="isManager || isAdmin"
              @click="openModal('createTeam')"
              class="flex bg-black text-primaryLight text-[14px] font-medium px-6 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
            >
              Create a New Team
            </button>
          </div>
        </div>
      </div>
      <div
        class="flex ml-auto justify-between mb-8 space-x-6 py-1 text-[14px] rounded-[6px] items-center"
      >
        <!-- <TabComponent
          :tabs="teamsTabs"
          v-model="activeTeamTab"
          :compact="false"
        /> -->
      </div>

      <!-- Conditional rendering of components based on active tab -->
      <!-- <CreateTeamModal
          ref="createTeamModal"
          :projects="projects"
          :projectId="project?.project_id"
          :showModal="showCreateTeamModal"
          :talents="talents"
          :selectedTalent="talent"
          :members="members"
          :teams="teams"
          :talentName="talentName"
          :talentEmail="talentEmail"
          :teamName="teamName"
          :isCreateTeam="isCreateTeam"
          :prefilledTask="prefilledTask"
          :TaskAssignedTo="TaskAssignedTo"
          @close="closeCreateTaskModal"
          @refresh-tasks="updateTaskList"
          @task-created="handleTaskCreated"

        /> -->
      
      <CreateTeamModal
        :showModal="showModal"
        :mode="modalMode"
        :projects="projects"
        :preSelectedProjectId="preSelectedProjectId"
        :preSelectedTeamId="preSelectedTeamId"
        @close="closeModal"
        @team-created="handleTeamCreated"
        @talents-added="handleTalentsAdded"
      />
        <CreateTeam
        v-if="activeTeamTab === 'Create a New Team'"
        :projects="projects"
        @team-created="handleTeamCreated"
        @change-tab="handleChangeTab"
      />

      <AddTalentToTeam
        v-if="activeTeamTab === 'Add Talent to a Team'"
        :projects="projects"
        :pre-selected-project-id="preSelectedProjectId"
        :pre-selected-team-id="preSelectedTeamId"
        @talents-added="handleTalentsAdded"
        @error="handleError"
      />

      <AllTeams
        v-if="activeTeamTab === 'All Teams'"
        :projects="projects"
        @team-deleted="handleTeamDeleted"
        @error="handleError"
      />

    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import HeaderComponent from "../HeaderComponent.vue";
// import TabComponent from "../profiles/TabComponent.vue";
import CreateTeam from "./CreateTeam.vue";
import AddTalentToTeam from "./AddTalentToTeam.vue";
import AllTeams from "./AllTeams.vue";
import { createTabStateManager } from "@/utils/tabStateManager";
import CreateTeamModal from "../modals/CreateTeamModal.vue";

export default {
  name: "TeamComponent",
  components: {
    HeaderComponent,
    // TabComponent,
    CreateTeam,
    AddTalentToTeam,
    AllTeams,
    CreateTeamModal,
  },
  data() {
    return {
      projects: [],
      talents: [],
      teamsTabs: ["Create a New Team", "Add Talent to a Team", "All Teams"],
      activeTeamTab: "", // Will be loaded from localStorage
      viewMode: "list",
      projectId: this.$route.params.projectId,
      loading: true,
      preSelectedProjectId: null,
      preSelectedTeamId: null,
      // Tab state manager
      tabStateManager: null,
      showCreateTeamModal: false,
      showModal: false,
      modalMode: 'createTeam',
      currentPage: 1,
      totalPages: 1,
      pageSize: 100,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    currentUser() {
      return this.$store.state.user || {};
    },
    // Create a unique identifier for the current user
    userIdentifier() {
      return (
        this.currentUser.id ||
        this.currentUser.user_id ||
        this.currentUser.email ||
        "anonymous"
      );
    },
  },
  watch: {
    // Watch for activeTeamTab changes and save to localStorage
    activeTeamTab: {
      handler(newTab) {
        if (this.tabStateManager && newTab) {
          this.tabStateManager.setActiveTab(newTab);
        }
      },
      immediate: false,
    },

    "$store.state.user": {
      handler(newUser, oldUser) {
        if (newUser && newUser !== oldUser) {
          // Reinitialize tab state when user changes
          this.initTabState();
        }
      },
      deep: true,
    },
  },
  methods: {
        openModal(mode, options = {}) {
      this.modalMode = mode;
      this.preSelectedProjectId = options.projectId || null;
      this.preSelectedTeamId = options.teamId || null;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.modalMode = 'createTeam';
      this.preSelectedProjectId = null;
      this.preSelectedTeamId = null;
    },
    setActiveTab(tab) {
      console.log("Setting active tab to:", tab); // Debug log
      this.activeTeamTab = tab;

      // Reset pre-selected values when manually changing tabs
      if (tab !== "Add Talent to a Team") {
        this.preSelectedProjectId = null;
        this.preSelectedTeamId = null;
      }
    },

    initTabState() {
      if (this.storageListener) {
        window.removeEventListener("storage", this.storageListener);
      }

      const userSpecificKey = `teamComponent_activeTeamTab${this.userIdentifier}`;

      // Create tab state manager with unique storage key for this component
      this.tabStateManager = createTabStateManager(
        userSpecificKey, // user_specific storage key
        "All Teams", // Default tab
        this.teamsTabs // Available tabs
      );

      // Load the saved tab from localStorage
      const savedTab = this.tabStateManager.getActiveTab();
      this.activeTeamTab = savedTab;

      // Listen for tab changes from other browser tabs/windows
      this.storageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          this.activeTeamTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.storageListener);
    },

    cleanupOldTabPreferences() {
      // Remove the old non-user-specific key if it exists
      if (localStorage.getItem("activeTeamTab")) {
        localStorage.removeItem("activeTeamTab");
      }

      // Clean up any old user-specific keys that might be orphaned
      // This is optional and can be removed if not needed
      const keysToCleanup = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (
          key &&
          key.startsWith("activeTeamTab") &&
          !key.includes("teamComponent_")
        ) {
          keysToCleanup.push(key);
        }
      }
      keysToCleanup.forEach((key) => localStorage.removeItem(key));
    },

    async fetchProjects(page = 1) {
      try {
        let response;

        if (this.isManager) {
          response = await apiClient.get(`/web/manager/me`);
          const managerData = response.data.data;
          this.projects = managerData.projects || [];
        } else if (this.isAdmin) {
          response = await apiClient.get("/web/projects_all", {
            params: {
            page: page,
            limit: this.pageSize,
          },
          });
          this.projects = response.data.data || [];
        } else if (this.isTalent) {
          response = await apiClient.get("/web/talent/me");
          const talentData = response.data.data;
          this.projects = talentData.projects || [];
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        this.handleError("Failed to load projects. Please try again.");
      } finally {
        this.loading = false;
      }
    },

    handleTeamCreated(team) {
      this.$toast.success(`Team "${team.team_name}" was successfully created!`);
    },

    handleChangeTab(tabName, data) {
      // Set the pre-selected values if provided
      if (data) {
        if (data.project_id) this.preSelectedProjectId = data.project_id;
        if (data.team_id) this.preSelectedTeamId = data.team_id;
      }

      // Change the active tab (this will trigger the watcher and save to localStorage)
      this.setActiveTab(tabName);
    },

    handleTalentsAdded(data) {

      const successCount = data.talent_ids.length;

      if (successCount === 1) {
        const name =
          data.talent_names && data.talent_names.length > 0
            ? data.talent_names[0]
            : "Talent";
        this.$toast.success(`${name} successfully added to the team!`);
      } else {
        this.$toast.success(`${successCount} talents successfully added to the team!`);
      }

      // Reset pre-selected values
      this.preSelectedProjectId = null;
      this.preSelectedTeamId = null;
    },

    handleTeamDeleted(teamId) {
      this.$toast.success(`Team was successfully deleted!`);
      console.log(teamId);
    },

    handleError(message) {
      this.$toast.error(message);

    },
      openCreateTeamModal(task = null) {
      this.prefilledTask = task;
      this.isAddTalentToTeam = false;
      this.talentName = task && task.talent
        ? `${task.talent.first_name} ${task.talent.last_name}`
        : "";
      this.talentEmail = task && task.talent ? task.talent.email : "";
      this.teamName = task && task.team ? task.team.name : "";
      this.showCreateTeamModal = true;
      if (this.$refs.createTeamModal) {
        // this.$refs.createTeamModal.clearErrorMessage();
      }
    },
    
    closeCreateTeamModal() {
      this.showCreateTeamModal = false;
      // this.fetchTs(this.project.project_id);
    },
        async fetchProjectMembers(projectId) {
      if (!projectId) {
        console.log('No project ID provided for fetching members');
        return;
      }

      try {
        this.talentsLoading = true;

        const response = await apiClient.get(`/web/projects/${projectId}/project_members/`);

        if (response.data && response.data.data) {
          this.talents = response.data.data;
          console.log(`Loaded ${this.talents.length} talents:`, this.talents);
        } else {
          console.error('Unexpected response format:', response);
          this.$toast.error('Received invalid data format from server');
          this.talents = [];
        }
      } catch (error) {
        console.error('Error fetching project members:', error);
        this.$toast.error(error.response?.data?.message || 'Failed to load project members');
        this.talents = [];
      } finally {
        this.talentsLoading = false;
      }
    },
  },

  created() {
    // Initialize tab state first (after user data is available)
    this.$nextTick(() => {
      this.initTabState();
    });

    // Then fetch projects
    this.fetchProjects();

    this.cleanupOldTabPreferences();
  },

  beforeUnmount() {
    // Clean up storage listener
    if (this.storageListener) {
      window.removeEventListener("storage", this.storageListener);
    }
  },
};
</script>
